import http from './utils';
import { prefix } from './constants';

// 顶层时间下拉框
export function getWeeklyEffectiveTimeList(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/account_summary/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 官号筛选器
export function getWeeklyAccount_AccountFilter(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/stat/display_names`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 日历
export function getWeeklyAccountCalendar(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/notebook/get`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

export function modifyWeeklyAccountCalendar(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/notebook/save`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 富文本
export function getWeeklyAccountRichText(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/account_summary/first`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

export function modifyWeeklyAccountRichText(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/account_summary/update`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 表格
export function getWeeklyAccountTable(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/stat/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 图表
export function getWeeklyAccountCharts(payload: any) {
  return http({
    url: `${prefix}/weekly_report/account/stat/timeline`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}


